import React from 'react';


const WhyUsBox = ({ iconSrc, altText, title, description }) => {
  return (
    <div className="why-us-box">
      <div className="icon">
        <img src={iconSrc} alt={altText} />
      </div>
      <h3>{title}</h3>
       {typeof description === "string" ? (
        <p>{description}</p>
      ) : (
        <div className='description'>{description}</div>
      )}
    </div>
  );
};

export default WhyUsBox;
